import React, { useState } from "react";
import { useAuth } from "../firebase/AuthContext"; // Ensure correct path
import "./PasswordChange.css";
import { useNavigate } from "react-router-dom";

const PasswordChange = () => {
  const { updateUserPassword } = useAuth();
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setError("");
    // setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    try {
      const message = await updateUserPassword(oldPassword, newPassword);
      alert(message); // ✅ Alert will show the message returned from AuthContext
      navigate("/"); // ✅ Redirect to login page after success
    //   setSuccess(message);
    //   setOldPassword("");
    //   setNewPassword("");
    //   setConfirmPassword("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="password-change-container">
      <form onSubmit={handlePasswordChange}>
        <h2 className="password-change-heading">Change Password.</h2>

        {error && <p className="error-message">{error}</p>}
        {/* {success && <p className="success-message">{success}</p>} */}

        <label>Old Password</label>
        <div className="wrapper">
          <i className="ri-lock-2-line" />
          <input
            type="password"
            name="oldPassword"
            placeholder="Enter old password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
          />
        </div>

        <label>New Password</label>
        <div className="wrapper">
          <i className="ri-lock-password-line" />
          <input
            type="password"
            name="newPassword"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>

        <label>Confirm Password</label>
        <div className="wrapper">
          <i className="ri-lock-password-line" />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Enter confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit">Change Password</button>
      </form>
    </div>
  );
};

export default PasswordChange;






// import React, { useState, useEffect} from 'react';
// import './PasswordChange.css';

// const PasswordChange = () => {
    
//   return (
//     <>
//       <div className='password-change-container'>
//         <form >
//             <h2 className='password-change-heading' >Change Password.</h2>
//             <label>Old Password </label>
//             <div class="wrapper">
//               <i class="ri-lock-2-line" />
//               <input type='text'  
//                      name='password' 
//                      placeholder='enter old password' 
//                      required
//                />
//             </div>
//             <label>New Password </label>
//             <div class="wrapper">
//               <i class="ri-lock-password-line" />
//               <input type='text'  
//                      name='password' 
//                      placeholder='enter new password'  
//                      required
//                />
//             </div>
//             <label>Confirm Password </label>
//             <div class="wrapper">
//               <i class="ri-lock-password-line" />
//               <input type='text'  
//                      name='password' 
//                      placeholder='enter confirm password' 
//                      required
//                />
//             </div>
//             <button type="submit">Change Password</button>
//         </form>
//       </div>
//     </>
//   )
// }

// export default PasswordChange